import type { TOC } from '@ember/component/template-only';

import FormCheckbox from 'webapp/components/form/checkbox';

import type { AnyBatchSelect } from 'webapp/models-custom/batch-select';

interface CommonBatchTableHeaderComponentInterface {
	Element: HTMLDivElement;
	Args: {
		batchSelect: AnyBatchSelect;
	};
}

const BatchTableHeaderComponent: TOC<CommonBatchTableHeaderComponentInterface> = <template>
	<th class="cc">
		<FormCheckbox
			@selected={{@batchSelect.isEverythingSelected}}
			@theme="blue"
			@onChange={{@batchSelect.toggleSelectAll}}
		/>
	</th>
</template>;

export default BatchTableHeaderComponent;
